import { useLocation, Link } from 'react-router-dom';
import { MAIN } from '../common/routes';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    return (
        <div style={{ fontSize: '14px' }}>
            <Link to={MAIN}>main</Link>
            {pathnames.map((name, index) => {
                const routeTo = '/' + pathnames.slice(0, index + 1).join('/');
                const isLast = index === pathnames.length - 1;
                return (
                    <span key={name}>
                        {' / '}
                        {isLast ? (
                            <span>{decodeURIComponent(name)}</span>
                        ) : (
                            <Link to={routeTo}>{decodeURIComponent(name)}</Link>
                        )}
                    </span>
                );
            })}
        </div>
    );
};

export default Breadcrumbs;
